export default {
  cookies: {
    ACCESS_TOKEN: 'auth.access_token',
    AUTHENTICATED: 'auth.authenticated',
    EXPIRES_AT: 'auth.expires_at',
    ID_TOKEN: 'auth.id_token',
    REFRESH_TOKEN: 'auth.refresh_token',
  },
};
